document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  var crossSellCheckboxes = document.querySelectorAll(
    '.crossselling-product input[type="checkbox"]',
  );
  var variantInputs = document.querySelectorAll(".product-variant_input"); // Variant inputs

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent normal form submission

      // Get the main product variant ID
      var mainProductVariantId = form.querySelector('input[name="id"]').value;
      // Get the quantity of the main product from the input field
      var mainProductQuantity =
        parseInt(form.querySelector('input[name="quantity"]').value) || 1; // Default to 1 if not set

      // Get the additional products' variant IDs (checked checkboxes)
      var additionalProducts = [];

      crossSellCheckboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          var variantId = checkbox.getAttribute("data-variant-id");
          additionalProducts.push({
            id: variantId,
            quantity: 1, // Adjust quantity if needed for additional products
          });
        }
      });

      // Add the main product to the additionalProducts array
      additionalProducts.unshift({
        id: mainProductVariantId,
        quantity: mainProductQuantity, // Use the dynamic quantity from the input
      });

      // Send the AJAX request to Shopify's API to add multiple products to the cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: additionalProducts }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Optional: Redirect to cart page or show success message
          window.location.href = "/cart"; // Redirect to cart page
        })
        .catch((error) => {
          console.error("Error adding products to cart:", error);
        });
    });
  }

  // Select all cross-selling product containers
  const crossselling = document.querySelectorAll(".crossselling-product");

  // Function to calculate and update total price
  function updateTotalPrice() {
    let totalPrice = parseFloat(
      document.querySelector("#default-price").dataset.exclPrice,
    ); // Base price from the main product
    let totalComparePrice = document.querySelector("#default-compare-price"); // Base price from the main product
    if (totalComparePrice) {
      totalComparePrice = parseFloat(
        document.querySelector("#default-compare-price").dataset.exclPrice,
      ); // Base price from the main product
    }
    const vatPercentage = 21;

    // Add prices of selected cross-sell products
    crossselling.forEach(function (product, index) {
      const checkbox = product.querySelector(`input#check-${index + 1}`);
      const quantityInput = product.querySelector(`input[type="number"]`);
      if (checkbox && checkbox.checked) {
        const crossSellPrice = parseFloat(
          product.querySelector("[data-excl-price]").dataset.exclPrice,
        );
        totalPrice += crossSellPrice;
        if (totalComparePrice) {
          totalComparePrice += crossSellPrice;
        }
      }
    });

    // Convert to VAT-inclusive price if needed (adapt depending on your toggle logic)
    const includeVAT = sessionStorage.getItem("pricesIncludeVat") === "true";
    const finalPrice = includeVAT
      ? totalPrice * (1 + vatPercentage / 100)
      : totalPrice;
    const finalComparePrice = includeVAT
      ? totalComparePrice * (1 + vatPercentage / 100)
      : totalComparePrice;

    // Update the displayed total price
    document.querySelector("#total-price").innerHTML =
      `€${(finalPrice / 100).toFixed(2).replace(".", ",")}`;
    document
      .querySelector("#total-price")
      .setAttribute("data-excl-price", finalPrice);

    if (totalComparePrice) {
      // Update the displayed total compare price
      document.querySelector("#total-compare-price").innerHTML =
        `€${(finalComparePrice / 100).toFixed(2).replace(".", ",")}`;
      document
        .querySelector("#total-compare-price")
        .setAttribute("data-excl-price", finalComparePrice);
    }
  }

  // Set up the event listeners for each cross-sell product
  crossselling.forEach(function (product, index) {
    const label = product.querySelector(`label[for="check-${index + 1}"]`);
    const activeInput = product.querySelector(`input#check-${index + 1}`);

    // Toggle the checkbox and recalculate the price when clicked
    label.addEventListener("click", function () {
      activeInput.classList.toggle("active");
      updateTotalPrice(); // Update total price after toggling
    });
  });

  // Event listener for variant selection changes
  variantInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      updateTotalPrice(); // Recalculate the price when variant changes
    });
  });

  // Initially update the total price on page load
  updateTotalPrice();

  function syncInputsByVariantId(inputElement) {
    // Get the data-variant-id of the changed input
    const variantId = inputElement.getAttribute("data-variant-id");

    // Find all inputs with the same data-variant-id
    document
      .querySelectorAll(`input[data-variant-id="${variantId}"]`)
      .forEach(function (input) {
        if (input !== inputElement) {
          input.checked = inputElement.checked; // Sync the checked state
          input.dispatchEvent(new Event("change")); // Trigger a 'change' event
        }
      });
  }

  // Attach change event listener to all relevant inputs
  function attachEventListeners() {
    document
      .querySelectorAll("input[data-variant-id]")
      .forEach(function (input) {
        input.removeEventListener("change", handleInputChange); // Remove any existing listener to avoid duplicates
        input.addEventListener("change", handleInputChange);
      });
  }

  // Handler for input change events
  function handleInputChange(event) {
    syncInputsByVariantId(event.target); // Call the sync function
  }

  // Initially attach listeners to all inputs
  attachEventListeners();

  // If new elements are dynamically added (e.g., popup opened), reinitialize the event listeners
  document.addEventListener("popupOpened", function () {
    attachEventListeners(); // Reattach listeners when the popup is loaded
  });
});
